export type RecentSale = {
  id: string
  name: string
  location: string
  timeAgo: string
}

export const recentSales: RecentSale[] = [
  { id: 's1', name: 'Carlos M.', location: 'Monterrey, MX', timeAgo: 'hace 2 minutos' },
  { id: 's2', name: 'Alejandra R.', location: 'Madrid, ES', timeAgo: 'hace 6 minutos' },
  { id: 's3', name: 'Diego F.', location: 'Bogotá, CO', timeAgo: 'hace 9 minutos' },
  { id: 's4', name: 'Ricardo L.', location: 'Miami, US', timeAgo: 'hace 13 minutos' },
  { id: 's5', name: 'Sofía V.', location: 'Ciudad de México, MX', timeAgo: 'hace 17 minutos' },
  { id: 's6', name: 'Martín A.', location: 'Buenos Aires, AR', timeAgo: 'hace 21 minutos' },
  { id: 's7', name: 'Valentina P.', location: 'Santiago, CL', timeAgo: 'hace 24 minutos' },
  { id: 's8', name: 'Javier O.', location: 'Barcelona, ES', timeAgo: 'hace 28 minutos' }
]

export const soldToday = 63
export const spotsTotal = 100
